import { render } from "./AppKariyer.vue?vue&type=template&id=35ce3d92"
import script from "./AppKariyer.vue?vue&type=script&lang=js"
export * from "./AppKariyer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__